  $(function () {
    $("html").click(function(e) {
      if(e.target.id !== "sec_nav" && $(e.target).parents('#sec_nav').length == 0){
        $("#sec_nav").addClass('hide');
      }
      if(e.target.id == "nav_button" || $(e.target).parents('#nav_button').length > 0){
        $("#sec_nav").removeClass('hide');
      }
    });
  });


// WEBPACK FOOTER //
// client/application/header/bundle.js